import { EmptyValue } from "@/components/ui/empty-value";
import { ValuationDeltaIcon } from "@/components/vehicle-valuation/valuation-delta-icon";
import { ArrowRight } from "lucide-react";
import { ReactNode } from "react";

interface ValuationComparisonRowProps {
  label: string;
  originalValue: ReactNode;
  confirmedValue: ReactNode;
  originalNumber?: number | null;
  confirmedNumber?: number | null;
}

export function ValuationComparisonRow({
  label,
  originalValue,
  confirmedValue,
  originalNumber,
  confirmedNumber,
}: ValuationComparisonRowProps) {
  const hasConfirmed = confirmedNumber != null;

  return (
    <div>
      <div className="text-muted-foreground text-xs font-medium">{label}</div>
      {hasConfirmed ? (
        <div className="flex items-center gap-2 text-sm">
          <span className="text-muted-foreground">{originalValue}</span>
          <ArrowRight className="text-muted-foreground h-3 w-3 shrink-0" />
          <span className="font-medium">{confirmedValue}</span>
          <ValuationDeltaIcon generated={originalNumber} confirmed={confirmedNumber} className="h-4 w-4 shrink-0" />
        </div>
      ) : (
        <div className="text-sm">{originalValue ?? <EmptyValue />}</div>
      )}
    </div>
  );
}
